import { ProductInformation } from './product-information';
import { EquipmentClass } from '../enum/equipmentClass';
import { PreviousProductType } from '../enum/previousProductType';
import { CleaningStatus } from '../enum/cleaningStatus';
import { TruckType } from '../enum/truckType';

export class TransportInformation {
  id: number;
  orderId: number;
  tankContainerLicensePlate?: string;
  semitrailerLicensePlate: string;
  truckLicensePlate: string;
  tareWeight?: number;
  maximumGrossWeight?: number;
  numberOfSeals?: number;
  companyName: string;
  driverName: string;
  driverMobileNumber: string;
  cleanCertificateIsNotOlderThan72: boolean;
  previousProductType: PreviousProductType;
  equipmentClass?: number;
  cleaningStatus?: number;
  productInformation: ProductInformation[] = [];
  scopaId: string;
  truckType?: TruckType;

  constructor(orderId: number) {
    this.id = 0;
    this.orderId = orderId;
    this.tankContainerLicensePlate = null;
    this.semitrailerLicensePlate = null;
    this.truckLicensePlate = null;
    this.tareWeight = null;
    this.maximumGrossWeight = null;
    this.numberOfSeals = null;
    this.companyName = null;
    this.driverMobileNumber = null;
    this.cleanCertificateIsNotOlderThan72 = null;
    this.driverName = null;
    this.previousProductType = null;
    this.equipmentClass = null;
    this.cleaningStatus = null;
    this.productInformation = [];
    this.scopaId = null;
    this.truckType = TruckType.Unknown;
  }
}
